import React, { Component } from 'react';
import LeftBar from '../Site/LeftBar';
import StationEntry from './StationEntry.js';

import './style.css';

class StationList extends Component { 

  render() {
    return (
      <div>
        <LeftBar />
        <StationEntry />
      </div>

    );
  }
}

export default StationList;